import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from 'components/buttons/Button';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withNamespaces } from 'react-i18next';
import { apiMicrosoftOauthUrl } from 'constants/apiRouting';
import { CREATE_MICROSOFT_OAUTH_CONFIG } from 'constants/analytics';
import { ReactComponent as Office365Logo } from 'icons/office365.svg';
import { redirectApp } from 'utils/misc';
import { analyticsTrack } from 'utils/analytics';

class EmailMicrosoftOauthCreate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    accountId: PropTypes.string.isRequired,
    btnLabel: PropTypes.string,
    startIcon: PropTypes.element,
    btnProps: PropTypes.shape({}),
  };

  static defaultProps = {
    className: '',
    btnLabel: 'Office 365',
    startIcon: <Office365Logo />,
    btnProps: {},
  };

  handleSuccess = () => {
    analyticsTrack(CREATE_MICROSOFT_OAUTH_CONFIG, { account: this.props.accountId }, true);
    redirectApp(apiMicrosoftOauthUrl(), { account_id: this.props.accountId });
  }

  render() {
    const {
      className,
      btnLabel,
      startIcon,
      btnProps,
    } = this.props;
    return (
      <div className={className}>
        <Button
          className="mb-2 pl-2"
          color="secondary"
          startIcon={startIcon}
          onClick={this.handleSuccess}
          variant="outlined"
          disabled
          {...btnProps}
        >
          {btnLabel}
        </Button>
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({
      config: state.config,
    }),
    {},
  ),
  withNamespaces('common'),
)(EmailMicrosoftOauthCreate);
